
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ComplianceDocumentsAdminResponse,
  DocumentRejectionRequest,
} from '../models';
import {
    ComplianceDocumentsAdminResponseFromJSON,
    ComplianceDocumentsAdminResponseToJSON,
    DocumentRejectionRequestFromJSON,
    DocumentRejectionRequestToJSON,
} from '../models';

export interface CreateUserAndForceKycRefreshRequest {
    companyId: string;
}

export interface DocumentRejectionOperationRequest {
    complianceFileId: string;
    documentRejectionRequest: DocumentRejectionRequest;
}

export interface ForceKycRefreshRequest {
    companyId: string;
}

export interface GetDocumentsAdminRequest {
    companyId: string;
}

export interface InternalDocumentValidationRequest {
    complianceFileId: string;
}

export interface RunBatchRequest {
    batchName: string;
    totalItems: number;
    startId?: string;
}

export interface UploadLatestToMangopayRequest {
    companyId: string;
    documentTypeId: string;
}

/**
 * 
 */
export class ComplianceDocumentAdminApi extends runtime.BaseAPI {

    /**
          */
    async createUserAndForceKycRefreshRaw(requestParameters: CreateUserAndForceKycRefreshRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling createUserAndForceKycRefresh().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/compliance/company/{companyId}/force/kyc/refresh`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async createUserAndForceKycRefresh(requestParameters: CreateUserAndForceKycRefreshRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.createUserAndForceKycRefreshRaw(requestParameters, initOverrides);
    }

    /**
          */
    async documentRejectionRaw(requestParameters: DocumentRejectionOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['complianceFileId'] == null) {
            throw new runtime.RequiredError(
                'complianceFileId',
                'Required parameter "complianceFileId" was null or undefined when calling documentRejection().'
            );
        }

        if (requestParameters['documentRejectionRequest'] == null) {
            throw new runtime.RequiredError(
                'documentRejectionRequest',
                'Required parameter "documentRejectionRequest" was null or undefined when calling documentRejection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/admin/compliance/company/{complianceFileId}/rejection`.replace(`{${"complianceFileId"}}`, encodeURIComponent(String(requestParameters['complianceFileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentRejectionRequestToJSON(requestParameters['documentRejectionRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async documentRejection(requestParameters: DocumentRejectionOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.documentRejectionRaw(requestParameters, initOverrides);
    }

    /**
          */
    async forceKycRefreshRaw(requestParameters: ForceKycRefreshRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling forceKycRefresh().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/compliance/company/{companyId}/kyc/refresh`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async forceKycRefresh(requestParameters: ForceKycRefreshRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.forceKycRefreshRaw(requestParameters, initOverrides);
    }

    /**
          */
    async getDocumentsAdminRaw(requestParameters: GetDocumentsAdminRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ComplianceDocumentsAdminResponse>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getDocumentsAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ComplianceDocumentsAdminResponse>({
            path: `/compliance/api/admin/compliance/company/{companyId}/documents`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ComplianceDocumentsAdminResponseFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getDocumentsAdmin(requestParameters: GetDocumentsAdminRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ComplianceDocumentsAdminResponse> {
        const response = await this.getDocumentsAdminRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async internalDocumentValidationRaw(requestParameters: InternalDocumentValidationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['complianceFileId'] == null) {
            throw new runtime.RequiredError(
                'complianceFileId',
                'Required parameter "complianceFileId" was null or undefined when calling internalDocumentValidation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/compliance/company/{complianceFileId}/internal-validation`.replace(`{${"complianceFileId"}}`, encodeURIComponent(String(requestParameters['complianceFileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async internalDocumentValidation(requestParameters: InternalDocumentValidationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.internalDocumentValidationRaw(requestParameters, initOverrides);
    }

    /**
          */
    async runBatchRaw(requestParameters: RunBatchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['batchName'] == null) {
            throw new runtime.RequiredError(
                'batchName',
                'Required parameter "batchName" was null or undefined when calling runBatch().'
            );
        }

        if (requestParameters['totalItems'] == null) {
            throw new runtime.RequiredError(
                'totalItems',
                'Required parameter "totalItems" was null or undefined when calling runBatch().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['batchName'] != null) {
            queryParameters['batchName'] = requestParameters['batchName'];
        }

        if (requestParameters['startId'] != null) {
            queryParameters['startId'] = requestParameters['startId'];
        }

        if (requestParameters['totalItems'] != null) {
            queryParameters['totalItems'] = requestParameters['totalItems'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/compliance/run-batch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async runBatch(requestParameters: RunBatchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.runBatchRaw(requestParameters, initOverrides);
    }

    /**
          */
    async uploadLatestToMangopayRaw(requestParameters: UploadLatestToMangopayRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling uploadLatestToMangopay().'
            );
        }

        if (requestParameters['documentTypeId'] == null) {
            throw new runtime.RequiredError(
                'documentTypeId',
                'Required parameter "documentTypeId" was null or undefined when calling uploadLatestToMangopay().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/compliance/company/{companyId}/document-type/{documentTypeId}/upload-latest-to-mangopay`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))).replace(`{${"documentTypeId"}}`, encodeURIComponent(String(requestParameters['documentTypeId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async uploadLatestToMangopay(requestParameters: UploadLatestToMangopayRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.uploadLatestToMangopayRaw(requestParameters, initOverrides);
    }

}
